import React from 'react';
import { func, bool } from 'prop-types';

import Icon from 'foundations/Icons/Icon';

import styles from './MapControls.css';

const MapControls = ({
    satellite,
    clickMapType,
    clickCenter,
    clickZoomIn,
    clickZoomOut 
  }) => (
  <div className={styles.mapUi}>
    <div className={styles.mapControl} onClick={clickMapType}>
      <Icon icon={satellite ? 'map' : 'world'} type={'20'} />
    </div>
    <div className={styles.mapControl} onClick={clickCenter}>
      <Icon icon={'current-position'} type={'20'} />
    </div>
    <div className={styles.mapControl} onClick={clickZoomIn}>
      <Icon icon={'expand'} type={'20'} />
    </div>
    <div className={styles.mapControl} onClick={clickZoomOut}>
      <Icon icon={'collapse'} type={'20'} />
    </div>
  </div>
);


MapControls.propTypes = {
  satellite: bool,
  clickMapType: func,
  clickCenter: func,
  clickZoomIn: func,
  clickZoomOut: func
};

export default MapControls;



// WEBPACK FOOTER //
// ./src/uis/components/Map/MapControls/MapControls.js